import { DateTime } from 'luxon';

export const getLocalDate = (createdAt) => {


	// const localVariant = DateTime.fromISO(item.createdAt);
	// return localVariant.toString();
	try {
		const localVariant = DateTime.fromISO(createdAt).toString();
		const anotherVariant = localVariant.substring(0, 10).split('-').reverse().join('-');
		// Разделяем строку на части
		const [day, month, year] = anotherVariant.split('-');

		// Убираем первые два символа из года
		const modifiedYear = year.slice(2);

		// Собираем новую строку
		const result = `${day}.${month}.${modifiedYear}`;
		const str = `${result} ${`0${new Date(createdAt).getHours()}`.slice(-2)}:${`0${new Date(createdAt).getMinutes()}`.slice(-2)}:${`0${new Date(createdAt).getSeconds()}`.slice(-2)}`;



		return str;
	} catch (error) {
		return createdAt;
	}

}